var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1545 26.6663C9.55717 26.6663 9.04873 26.4565 8.62917 26.037C8.20962 25.6174 7.99984 25.1094 7.99984 24.513V7.99965H6.6665V6.66632H11.9998V5.63965H19.9998V6.66632H25.3332V7.99965H23.9998V24.513C23.9998 25.1263 23.7945 25.6388 23.3838 26.0503C22.9732 26.4619 22.4603 26.6672 21.8452 26.6663H10.1545ZM22.6665 7.99965H9.33317V24.513C9.33317 24.7521 9.41006 24.9485 9.56384 25.1023C9.71761 25.2561 9.9145 25.333 10.1545 25.333H21.8465C22.0509 25.333 22.2389 25.2477 22.4105 25.077C22.5821 24.9063 22.6674 24.7179 22.6665 24.5117V7.99965ZM13.0772 22.6663H14.4105V10.6663H13.0772V22.6663ZM17.5892 22.6663H18.9225V10.6663H17.5892V22.6663Z",
    fill: "#433E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8531a08d5332bc854b963161af5cefe3.svg";
export { ForwardRef as ReactComponent };